// extracted by mini-css-extract-plugin
export var buttons = "ctaEduWork-module--buttons--uN5eh";
export var sbShowMain = "ctaEduWork-module--sb-show-main--UViIy";
export var text = "ctaEduWork-module--text--A6Aom";
export var title = "ctaEduWork-module--title--jkT1j";
export var wrapper = "ctaEduWork-module--wrapper--cebmw";